import { Footer } from '../Footer';
import { RedBanner } from '../RedBanner';
import { RentFastNSave } from '../RentFastNSave';
import { WhyWeRent } from '../WhyWeRent';
import * as style from './Content.css';
import { RentProfit } from '../RentProfit';
import { Faq } from '../Faq';
import { Convenient } from '../Convenient';
import { FindToday } from '../FindToday';

interface IContentProps {
  header: JSX.Element;
  solveProblems: JSX.Element;
  protectYou: JSX.Element;
  aboutService: JSX.Element;
  reviews: JSX.Element;
  modal: JSX.Element;
  onChangeVisibleModal: VoidFunction;
}

export const Content: React.FC<IContentProps> = ({
  header,
  solveProblems,
  protectYou,
  aboutService,
  modal,
  reviews,
  onChangeVisibleModal,
}) => {
  return (
    <div className={style['container']}>
      {header}
      <div className={style['wrapper']}>
        <RentFastNSave onChangeModalVisible={onChangeVisibleModal} />
        {solveProblems}
        <RedBanner onChangeModalVisible={onChangeVisibleModal} />
        <WhyWeRent />
        {protectYou}
        <Convenient />
        {aboutService}
        <RentProfit />
        {reviews}
        <Faq />
        <FindToday onOpenModal={onChangeVisibleModal} />
        {modal}
      </div>
      <Footer />
    </div>
  );
};
